import { CloseButton, Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { X } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { NavbarItem } from '@/components/common/NavBar';

export type MobileSidebarProps = PropsWithChildren<{ open: boolean; close: () => void }>;

const MobileSidebar = ({ open, close, children }: MobileSidebarProps) => (
    <Dialog open={open} onClose={close} className="lg:hidden">
        <DialogBackdrop
            transition
            className="fixed inset-0 z-20 bg-black/30 transition data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in"
        />
        <DialogPanel
            transition
            className="fixed inset-y-0 z-30 w-full max-w-80 p-2 transition duration-300 ease-in-out data-closed:-translate-x-full"
        >
            <div className="bg-neutral-0 flex h-full flex-col rounded-lg shadow-xs ring-1 ring-neutral-300">
                <div className="relative -mb-3 px-4 pt-3">
                    <div className="absolute top-4 right-2">
                        <CloseButton as={NavbarItem} aria-label="Close navigation">
                            <X className="text-neutral-500" />
                        </CloseButton>
                    </div>
                </div>
                <div className="mobile-view flex-1 overflow-y-auto">{children}</div>
            </div>
        </DialogPanel>
    </Dialog>
);

export default MobileSidebar;
